import { render, staticRenderFns } from "./VideoSearchModal.vue?vue&type=template&id=5209ed19&scoped=true&"
import script from "./VideoSearchModal.vue?vue&type=script&lang=js&"
export * from "./VideoSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./VideoSearchModal.vue?vue&type=style&index=0&id=5209ed19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5209ed19",
  null
  
)

export default component.exports